export default __webpack_public_path__ + "static/media/murder mystery.27aaba21.jpg";